module.exports = __webpack_public_path__ + "assets/img/H.3cf1fc15.png";